// import { useTranslationContext } from "@providers/TranslationProvider";
import Banner from "@components/Banner";
import Breadcrumb from "@components/Breadcrumbs";
import Footer from "@components/Footer";
import Header from "@components/Header";
import { useRouteContext } from "@providers/RouteProvider";
import OtherRooms from "@components/RoomDetail/OtherRooms";
import Overview from "@components/RoomDetail/Overview";
import TheDetails from "@components/RoomDetail/TheDetails";
import _ from "lodash";
import StayInspired from "@components/Home/StayInspired";
import FAQs from "@components/RoomDetail/FAQs";
import { usePageContext } from "@providers/PageProvider";
import helper, { roomPage } from "@utils/helper";
const View = () => {
  const { pageData, rooms, hotel } = usePageContext();
  // const data = _.get(room, "attributes", {});
  const { router } = useRouteContext();
  // const banner = helper.formatBanner(pageData);
  const data = roomPage.formatRoomPage(pageData);
  const footer = helper.renderDetailsFooter(hotel);
  return (
    <div className="bg-black" data-scroll-container>
      <Header />
      <Banner image={data?.image} title={data?.title} type="room-detail" />
      <Breadcrumb
        data={router.breadcrumbs("room-detail", { ...data, hotel })}
      />
      <Overview />
      <TheDetails data={data} />
      <OtherRooms data={rooms} />
      {/* <Offer /> */}
      <FAQs />
      <StayInspired />
      <Footer
        data={{
          name: footer.name,
          address: footer.address,
          email: footer.email,
          phone: footer.phone,
        }}
      />
    </div>
  );
};

export default View;
